import { PATHS } from '@tom-ui/utils'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import ContainerPinball from './ContainerPinball'

export const ContainerPinballPage: FC = () => {
  const navigate = useNavigate()
  return <ContainerPinball onClose={() => navigate(PATHS.arcade.url)} />
}
